<script setup>
// IMPORTS
import CloseIcon from "@/assets/icons/close.svg?raw";
import ErrorIcon from "@/assets/icons/toast/error.svg?raw";
import InfoIcon from "@/assets/icons/toast/info.svg?raw";
import SuccessIcon from "@/assets/icons/toast/success.svg?raw";
import WarnIcon from "@/assets/icons/toast/warn.svg?raw";

// DEPENDENCIES

// TYPES

// INJECT

// MODEL

// CONSTANTS

// PROPS, EMITS

// REFS

// COMPUTED
const getToastIcon = (severity) => {
  switch (severity) {
    case "success":
      return SuccessIcon;
    case "error":
      return ErrorIcon;
    case "warn":
      return WarnIcon;
    case "info":
      return InfoIcon;
    default:
      return InfoIcon;
  }
};

// COMPONENT METHODS AND LOGIC

// PROVIDE, EXPOSE

// WATCHERS

// LIFECYCLE METHODS (https://vuejs.org/api/composition-api-lifecycle.html)
</script>

<template>
  <Toast
    position="bottom-right"
    group="fm-toast"
    class="fm-toast absolute right-[16px] bottom-[16px] w-[484px]"
  >
    <template #container="{ message, closeCallback }">
      <div class="fm-toast-content flex flex-col justify-center gap-4 border">
        <div class="fm-toast-line-decoration" />
        <div class="flex items-center gap-4">
          <div
            class="fm-toast-icon ml-4 flex"
            v-html="getToastIcon(message.severity)"
          ></div>

          <div class="flex flex-col text-white">
            <span class="heading-xs font-bold">{{ message.summary }}</span>
            <span class="body-sm">{{ message.detail }}</span>
          </div>
        </div>

        <span
          class="close-button"
          @click="closeCallback"
          v-html="CloseIcon"
        >
        </span>
      </div>
    </template>
  </Toast>
</template>

<style>
.p-toast-message {
  border: 1px solid black !important;
  background: #000000cc !important;
  transition: background 0.3s ease-in-out;
}

.p-toast-message:hover {
  background: #000 !important;
}

.fm-toast .fm-toast-content {
  border-radius: 6px;
  padding: 16px;
  height: 98px;
  width: 484px;
}

.fm-toast .close-button {
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fm-toast .fm-toast-line-decoration {
  height: 64px;
  width: 4px;
  position: absolute;
  border-radius: 4px;
}

/* TYPES */
.p-toast-message-success {
  border: 1px solid #10ffa780 !important;
  color: transparent !important;
}

.p-toast-message-success .fm-toast-line-decoration {
  background: #10ffa7;
}

.p-toast-message-info {
  border: 1px solid #00fcda80 !important;
  color: transparent !important;
}

.p-toast-message-info .fm-toast-line-decoration {
  background: #00fcda;
}

.p-toast-message-warn {
  color: transparent !important;
  border: 1px solid #fbff2d80 !important;
}

.p-toast-message-warn .fm-toast-line-decoration {
  background: #fbff2d;
}

.p-toast-message-error {
  border: 1px solid #f63b3b80 !important;
  color: transparent !important;
}

.p-toast-message-error .fm-toast-line-decoration {
  background: #f63b3b;
}
</style>
